'use client';
import GenericError from 'components/generic-error/generic-error';
import { useEffect } from 'react';

export default function GlobalError({
  error,
  params
}: Readonly<{
  error: string;
  params: {
    lang: string;
  };
}>) {
  useEffect(() => {
    // Log the error to the console for better visibility
    console.error('Global error-->', error);
  }, [error]);
  return (
    <html lang={params?.lang}>
      <body>
        <GenericError />
      </body>
    </html>
  );
}
